module.exports = __webpack_public_path__ + "static/img/WarmPlate (20).855efb34.png";